import React, { useState, useEffect, useContext } from "react";
import { MdOutlineAir } from "react-icons/md";
import { 
  FaSprayCan, 
  FaBatteryFull, 
  FaBatteryThreeQuarters, 
  FaBatteryHalf, 
  FaBatteryQuarter, 
  FaBatteryEmpty 
} from "react-icons/fa6";

import "../CSS/VcSauDeviceParamsDashboard.css";
import axios from "axios";
import { getAPIHostURL } from "../../ClientConfig";
import { AppRelevantDataContext } from "../../AppContext";
import { IDS_AIR_FRESHNER_DEVICE, IDS_CONNECTED, IDS_DISCONNECTED, IDS_SPR_REMAINING, IDS_BTR_REMAINING  } from '../../VcLanguage';

function VcSauDeviceParamsDashboard() {
  const context = useContext(AppRelevantDataContext);

  let appRelevantDataContextValue = context;
  let t = appRelevantDataContextValue.t;
  // const [state, setState] = useState({
  //   deviceId: "",
  //   sprayPercentage: 0,
  //   batteryPercentage: 0,
  //   deviceStatus: "",
  //   // airFreshnerDeviceData: {},
  //   errors: {},
  // });

  const state = {
    deviceId: context.sauDeviceData?.deviceId || "",
    sprayPercentage: context.sauDeviceData?.sprayPercentage || 0,
    batteryPercentage: context.sauDeviceData?.batteryPercentage || 0,
    deviceStatus: context.sauDeviceData?.deviceStatus || "",
    errors: {},
  }
  // Determine if device is effectively connected
  // Device is disconnected if deviceStatus != 1 OR batteryPercentage is 0
  const isConnected = state.deviceStatus?.toString() == "1" && state.batteryPercentage > 0;

  useEffect(() => {
    var test = context;
  }, [context.selectedNodeInfo.nodeID, context.selectedNodeInfo.AddnlSAUDevc, context.sauDeviceData]);


  // Dynamic battery icon selection
  const renderBatteryIcon = (level) => {
    if (level >= 80) return <FaBatteryFull className="batteryIcon high" />;
    if (level >= 60) return <FaBatteryThreeQuarters className="batteryIcon high" />;
    if (level >= 25) return <FaBatteryHalf className="batteryIcon medium" />;
    if (level >= 20) return <FaBatteryQuarter className="batteryIcon low" />;
    return <FaBatteryEmpty className="batteryIcon critical" />;
  };

  if(state.deviceId === "" || state.deviceId === null || state.deviceId === undefined) {
    return <></>
  }

  return (
    <div className="sauDashboard">
      {/* Header */}
      <div className="sauHeader">
        <div className="sauHeaderLeft">
          <MdOutlineAir className="flowerIcon" />
          <span>{t(IDS_AIR_FRESHNER_DEVICE)}</span>
        </div>
        <div className="sauHeaderRight">
          <span
            className={`statusDot ${isConnected ? "online" : "offline"}`}
            style={{ backgroundColor: isConnected ? "#4caf50" : "#767575" }}>
            </span>
          <span>
            {isConnected ? t(IDS_CONNECTED) : t(IDS_DISCONNECTED)}
          </span>
        </div>
      </div>
      {/* Cards Section */}
      <div className="sauBody">
        {/* --- SPRAY CARD --- */}
        <div className="sauCard">
          <div className="cardContentRow">
            <div className="iconContainer sprayBox">
              <FaSprayCan className="sprayIcon" />
            </div>
            <div className="valueDisplay">
              <span className="boldValue">{state.sprayPercentage}%</span>
              <span className="valueSubtext">{t(IDS_SPR_REMAINING)}</span>
            </div>
          </div>
        </div>
        {/* --- BATTERY LEVEL CARD --- */}
        <div className="sauCard">
          <div className="cardContentRow">
            <div className="iconContainer batteryBox">
              {renderBatteryIcon(state.batteryPercentage)}
            </div>
            <div className="valueDisplay">
              <span className="boldValue">{state.batteryPercentage}%</span>
              <span className="valueSubtext">{t(IDS_BTR_REMAINING)}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default VcSauDeviceParamsDashboard;